const polyfills = {
  // add Function.name support for IE
  functionName: function() {
    if (Function.prototype.name === undefined && Object.defineProperty !== undefined) {
      /* eslint-disable no-extend-native */
      Object.defineProperty(Function.prototype, 'name', {
        get: function() {
          const results = /function\s([^(]{1,})\(/.exec(this.toString())
          return (results && results.length > 1) ? results[1].trim() : ''
        },
      })
      /* eslint-enable no-extend-native */
    }
  },

  // add Array.prototype.at() support for older browsers
  arrayAt: function() {
    if (!Array.prototype.at) {
      /* eslint-disable no-extend-native */
      Array.prototype.at = function(n) {
        // ToInteger() abstract op
        n = Math.trunc(n) || 0
        // Allow negative indexing from the end
        if (n < 0) n += this.length
        // OOB access is guaranteed to return undefined
        if (n < 0 || n >= this.length) return undefined
        // Otherwise, this is just normal property access
        return this[n]
      }
      /* eslint-enable no-extend-native */
    }
  },
}

export default {
  init: function() {
    console.log('🔧 Initializing polyfills...')
    for (const name in polyfills) {
      polyfills[name]()
    }
    console.log('✅ Polyfills initialized successfully')
  },

  test: function() {
    polyfills.test()
  },
}
